import React from 'react';
import styles from '../../Recurring.module.css';

const HowItWorks = () => (
  <section className={styles.sec} id="how">
    <div className={styles.container}>
      <div className={`${styles.secHead} ${styles.secHeadCenter} ${styles.sr}`} data-sr>
        <span className={styles.eyebrow}><span className={styles.dot} />How it works</span>
        <h2>Three steps, then hands-off.</h2>
        <p className={styles.secLead}>Build the invoice once, set the rhythm, and let Fyntiq handle every cycle.</p>
      </div>
      <div className={styles.steps}>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>01</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16v16H4z" /><path d="M8 9h8M8 13h5" />
            </svg>
          </div>
          <h3>Create the invoice once</h3>
          <p>Set the amount, the line items, recipients, and a custom message — then save it.</p>
        </div>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>02</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" />
            </svg>
          </div>
          <h3>Choose the schedule</h3>
          <p>Weekly, monthly, or a custom cadence — with start and end dates and time-zone control.</p>
        </div>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>03</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12a9 9 0 1 1-3-6.7M21 4v4h-4" />
            </svg>
          </div>
          <h3>Get paid automatically</h3>
          <p>Invoices send and payments collect on schedule. Pause or resume any time.</p>
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorks;
